<template>
  <div id="set">
    <div class="contentRight2">
      <div class="contentTabs">
        <el-tabs v-model="activeName">
          <!-- 门店管理标签 -->
          <el-tab-pane label="门店管理" name="first">
            <!-- 门店管理页面 -->
            <div v-if="pages == 1">
              <div class="middlePart">
                <el-button type="primary" class="button2" @click="pages = 2">创建分店</el-button>
                <div style="float:right" class="row">
                  <el-input
                    class="input1"
                    clearable
                    @keyup.enter.native="searchRequest('shops')"
                    v-model="searchShops"
                    placeholder="搜索门店名称"
                    @blur="searchContentBlur"
                  ></el-input>
                  <el-button class="searchButton" @click="searchRequest('shops')" type="primary">搜索</el-button>
                  <!-- <el-select
                    class="input1"
                    size="small"
                    @change="shopChange"
                    v-model="value"
                    placeholder="选择分店"
                  >
                    <el-option
                      v-for="item in shopList"
                      :key="item.storeName"
                      :label="item.storeName"
                      :value="item.shopStoreId"
                    ></el-option>
                  </el-select>-->
                  <!-- <el-select class="input1" vlaue="全部员工"></el-select> -->
                </div>
              </div>
              <!-- 门店管理表格 -->
              <div class="content">
                <table class="table" width="100%" style="table-layout:fixed">
                  <tr class="th">
                    <td>门店</td>
                    <td>今日收款（元）</td>
                    <td>员工（人）</td>
                    <td>操作</td>
                  </tr>
                  <tr class="td" v-for="(item,index) in shopList.list" :key="index">
                    <td
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{item.storeName}}</td>
                    <td style="color:#FF8080">￥{{item.gainMoney}}</td>
                    <td>{{item.shopWorkerNum}}</td>
                    <td>
                      <el-button class="button1" @click="edit(item)">编辑</el-button>
                      <el-button class="button1" @click="workDetail(item)">详情</el-button>
                    </td>
                  </tr>
                </table>
                <!-- 分页 -->
                <div
                  v-if="shopList.totalCount!=0"
                  class="block"
                  style="float:right;margin-top:10px;"
                >
                <!-- :current-page="1" -->
                  <el-pagination
                    @size-change="shopSizeChange"
                    @current-change="shopPageChange"
                    :current-page.sync = "pageNo"
                    :page-size="10"
                    layout="total, prev, pager, next, jumper"
                    :total="shopList.totalCount"
                  ></el-pagination>
                </div>
              </div>
            </div>
            <!-- 创建门店界面 -->
            <div v-if="pages == 2">
              <div class="billHead2" style="height:40px;">
                <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item>
                    <a @click="shopToHome()" href="javascript:;">门店管理</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>创建门店</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="createBranch">
                <div style="width:400px; ">
                  <el-form
                    :model="createShopFrom"
                    ref="createShopStore"
                    label-width="100px"
                    class="demo-dynamic"
                    hide-required-asterisk
                  >
                    <el-form-item
                      prop="shopName"
                      label="门店名称："
                      :rules="[{ required: true, message: '请输入门店名称', trigger: 'blur'  },
                            ]"
                    >
                      <el-input
                        autofocus="true"
                        placeholder="请输入门店名称"
                        v-model="createShopFrom.shopName"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      prop="shopAddress"
                      label="门店地址："
                      :rules="[{ required: true, message: '请输入门店地址', trigger: 'blur'  },
                            ]"
                    >
                      <el-input placeholder="请输入门店地址" v-model="createShopFrom.shopAddress"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        class="button2"
                        @click="Shop_createShopStore('createShopStore')"
                      >提交</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
            <!-- 修改门店信息界面 -->
            <div v-if="pages == 4">
              <div class="billHead2" style="height:40px;">
                <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item>
                    <a @click="pages = 1" href="javascript:;">门店管理</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>修改门店信息</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="createBranch">
                <div style="width:400px; ">
                  <el-form
                    :model="editShopFrom"
                    ref="Shop_updateShopStore"
                    label-width="100px"
                    class="demo-dynamic"
                    hide-required-asterisk
                  >
                    <el-form-item
                      prop="shopName"
                      label="门店名称："
                      :rules="[{ required: true, message: '请输入门店名称', trigger: 'blur'  },
                            ]"
                    >
                      <el-input placeholder="请输入门店名称" v-model="editShopFrom.shopName"></el-input>
                    </el-form-item>
                    <el-form-item
                      prop="shopAddress"
                      label="门店地址："
                      :rules="[{ required: true, message: '请输入门店地址', trigger: 'blur'  },
                            ]"
                    >
                      <el-input placeholder="请输入门店地址" v-model="editShopFrom.shopAddress"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        class="button2"
                        @click="Shop_updateShopStore('Shop_updateShopStore')"
                      >提交</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
            <!-- 门店详情界面 -->
            <div v-if="pages == 3">
              <div class="billHead2" style="height:40px;">
                <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item>
                    <a @click="pages = 1" href="javascript:;">门店管理</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>门店详情</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div v-if="shopDetailList" class="padding30" style="padding-top:70px">
                <div class="head row">
                  <div>
                    <div class="text3">总计收款</div>
                    <div class="text4">+{{shopDetailList.shopStoreIncomeStatistic}}</div>
                  </div>
                  <div style="margin-left:300px;">
                    <div class="text3">今日收款</div>
                    <div class="text4">+{{shopDetailList.dailyMoney}}</div>
                  </div>
                  <div class="shop">
                    <div>门店：{{shopDetailList.shopStore.storeName}}</div>
                    <div class="text5">地址：{{shopDetailList.shopStore.storeAddress}}</div>
                  </div>
                </div>
              </div>

              <!-- 详情表格 -->
              <div class="content" style="padding-top:0;margin:0">
                <div style="margin-bottom:20px;">
                  <el-button
                    type="primary"
                    size="small"
                    @click="pages2 = 2, activeName = 'second'"
                  >添加员工</el-button>
                </div>
                <table class="table">
                  <tr class="th">
                    <td>员工</td>

                    <td>操作</td>
                  </tr>
                  <tr
                    class="td"
                    v-for="(item,index) in this.shopDetailWorkerList.list"
                    :key="index"
                  >
                    <td class="row alignCenter">
                      <img :src="item.headLogo" alt />
                      <div class="text6">{{item.fullName}}</div>
                    </td>
                    <td>
                      <el-button class="button1" @click="redactWorks(item)">编辑</el-button>
                      <el-button
                        class="button1"
                        @click="dialogVisible = true,workerId = item.shopWorkerUserId"
                      >删除</el-button>
                      <!-- <el-button class="button1">停用</el-button> -->
                    </td>
                  </tr>
                </table>
                <!-- 分页 -->
                <!-- v-if="shopList.totalCount!=0" -->
                <div
                  v-if="shopDetailWorkerList.list&&shopDetailWorkerList.list.length!=0"
                  class="block"
                  style="float:right;margin-top:10px;"
                >
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="workerPages"
                    :page-size="5"
                    layout="total, prev, pager, next, jumper"
                    :total="shopDetailWorkerList.totalCount"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- 分类管理标签 -->
          <el-tab-pane id="fenye" label="员工管理" name="second">
            <!-- 员工管理页面 -->
            <div v-if="pages2 == 1">
              <div class="middlePart">
                <el-button type="primary" class="button2" @click="addWorkers">添加员工</el-button>
                <div style="float:right" class="row">
                  <el-select size="small" @change="shopChange" v-model="value" placeholder="选择分店">
                    <el-option
                      v-for="item in shopList3"
                      :key="item.storeName"
                      :label="item.storeName"
                      :value="item.shopStoreId"
                    ></el-option>
                  </el-select>
                  <el-input
                    class="input1"
                    @keyup.enter.native="searchRequest('workers')"
                    v-model="searchWorkers"
                    placeholder="搜索员工手机号"
                  ></el-input>
                </div>
              </div>
              <div v-if="workersList.pager" class="content">
                <table class="table">
                  <tr class="th">
                    <td>员工</td>
                    <td>所属门店</td>
                    <td>操作</td>
                  </tr>
                  <!-- <tr class="th2">
                    <td>{{item1.fullName}}</td>
                    <td></td>
                  </tr>-->
                  <tr class="td" v-if="workersList.pager.list.length == 0">
                    <td class="row alignCenter">暂无数据</td>
                  </tr>
                  <tr class="td" v-for="(item2,index2) in workersList.pager.list" :key="index2">
                    <td class="row alignCenter">
                      <img :src="item2.headLogo" alt />
                      <div class="text6">{{item2.fullName}}</div>
                    </td>
                    <td>{{item2.storeName}}</td>
                    <td>
                      <el-button class="button1" @click="redactWorks(item2)">编辑</el-button>
                      <!-- <el-button class="button1"  @click="delShopWorker(item2)">删除</el-button> -->
                      <el-button
                        class="button1"
                        @click="dialogVisible = true,workerId = item2.shopWorkerUserId"
                      >删除</el-button>
                      <el-button class="permission-btn" 
                        @click="set_permission(item2)">权限设置</el-button>
                      <!-- <el-button class="button1">停用</el-button> -->
                    </td>
                  </tr>
                </table>
                <!-- 分页 -->
                <div class="block" style="float:right;margin-top:10px;">
                  <el-pagination
                    @current-change="workersChange"
                    :current-page="1"
                    :page-size="20"
                    layout="total,  prev, pager, next, jumper"
                    :total="workersList.pager.totalCount"
                  ></el-pagination>
                </div>
              </div>
            </div>
            <!-- 添加员工界面 -->
            <div v-if="pages2 == 2">
              <div class="billHead2" style="height:40px;">
                <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item>
                    <a @click="workerToHome()" href="javascript:;">员工管理</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>添加员工</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="createBranch">
                <div class="row" style="    padding-left: 30px;margin-bottom:20px;"></div>
                <div style="width:300px;">
                  <el-form
                    :model="addWords"
                    ref="addWords"
                    label-width="100px"
                    class="demo-dynamic"
                    hide-required-asterisk
                    width="200px"
                  >
                    <el-form-item
                      prop="headLogo"
                      label="上传头像："
                    >
                      <el-upload
                        class="avatar-uploader"
                        action="https://api.yichengshi.cn/ImageServer/YmUpload_image"
                        list-type="picture-card"
                        :http-request="handleAvatarSuccess2"
                        :show-file-list="false"
                      >
                        <img v-if="addWords.imageUrl2" :src="addWords.imageUrl2" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <!-- <div class="text2" style="width:230px;">图片大小不得超过3M，建议使用方形图片</div> -->
                    </el-form-item>
                    <el-form-item
                      prop="fullName"
                      label="员工姓名："
                      :rules="[{ required: true, message: '请输入员工姓名', trigger: 'blur'  },
                            ]"
                    >
                      <el-input autofocus="true" placeholder="输入员工姓名" v-model="addWords.fullName"></el-input>
                    </el-form-item>
                    <!-- <el-form-item
                      prop="workerType"
                      label="权限："
                      :rules="[{ required: true, message: '请输选择权限', trigger: 'blur'  },
                            ]"
                    >
                      <el-select v-model="addWords.workerType" placeholder="选择权限">
                        <el-option
                          v-for="item in workerType"
                          :key="item.name"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>-->
                    <el-form-item
                      prop="shopStoreId"
                      label="所属门店："
                      :rules="[{ required: true, message: '请输选择门店', trigger: 'blur'  },
                            ]"
                    >
                      <el-select v-model="addWords.shopStoreId" placeholder="选择门店">
                        <el-option
                          v-for="item in shopList2"
                          :key="item.name"
                          :label="item.storeName"
                          :value="item.shopStoreId+','+item.shoperUserId"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      prop="roleId"
                      label="角色："
                      :rules="[{ required: true, message: '请输选择角色', trigger: 'blur'  },
                            ]"
                    >
                      <el-select v-model="addWords.roleId" placeholder="选择角色">
                        <el-option
                          v-for="item in roleList"
                          :key="item.name"
                          :label="item.name"
                          :value="item.roleId"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      prop="phoneNum"
                      label="手机号码："
                      :rules="[{ required: true,min:11,max:11, message: '请输入正确手机号码', trigger: 'blur'  },
                            ]"
                    >
                      <el-input placeholder="输入手机号" v-model="addWords.phoneNum"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" class @click="submitForm('addWords')">添加并发送初始密码到手机</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
            <!-- 编辑员工界面 -->
            <div v-if="pages2 == 3">
              <div class="billHead2" style="height:40px;">
                <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item>
                    <a @click="toManage" href="javascript:;">员工管理</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>编辑员工</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="createBranch">
                <div>
                  <el-form
                    :model="editWorkerFrom"
                    ref="editWorkerFrom"
                    label-width="100px"
                    class="demo-dynamic"
                    hide-required-asterisk
                  >
                    <el-form-item
                      prop="headLogo"
                      label="上传头像："
                    >
                      <el-upload
                        class="avatar-uploader"
                        action="https://api.yichengshi.cn/ImageServer/YmUpload_image"
                        list-type="picture-card"
                        :http-request="editHandleAvatarSuccess2"
                        :show-file-list="false"
                      >
                        <img v-if="editWorkerFrom.img" :src="editWorkerFrom.img" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <!-- <div class="text2" style="width:230px;">图片大小不得超过3M，建议使用方形图片</div> -->
                    </el-form-item>
                    <el-form-item
                      prop="fullName"
                      label="员工姓名："
                      :rules="[{ required: true, message: '请输入员工姓名', trigger: 'blur'  },
                            ]"
                    >
                      <el-input placeholder="输入员工姓名" v-model="editWorkerFrom.fullName"></el-input>
                    </el-form-item>
                    <el-form-item prop="fullName" label="所属门店：">
                      <!-- <el-input placeholder="输入员工姓名" v-model="editWorkerFrom.fullName"></el-input> -->
                      <div>{{editWorkerFrom.storeName}}</div>
                    </el-form-item>

                    <el-form-item label="角色：">
                      <div>{{editWorkerFrom.roleName}}</div>
                    </el-form-item>

                    <el-form-item
                      prop="phoneNum"
                      label="手机号码："
                      :rules="[{ required: true,min:11,max:11, message: '请输入手机号码', trigger: 'blur'  },
                            ]"
                    >
                      <el-input placeholder="输入手机号" v-model="editWorkerFrom.phoneNum"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        class="button2"
                        @click="Shop_updateShopWorker('editWorkerFrom')"
                      >保存</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <!-- 店铺认证标签 -->
          <!-- <el-tab-pane id="fenye" label="店铺认证" name="third">
            <div v-if="pages3 == 1">
              <div class="billHead2" style="height:40px;">
                <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item>
                    <a @click="pages3 = 1" href="javascript:;">店铺认证</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>填写店铺信息</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="BusinessInformation">
                <el-form
                  :model="certificationForm"
                  ref="certificationForm"
                  label-width="130px"
                  class="demo-ruleForm"
                  label-position="left"
                >
                  <el-form-item label="身份证正面：" prop="name">
                    <div class="row" style>
                      <div>
                        <el-upload
                          class="avatar-uploader"
                          action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                          :show-file-list="false"
                          list-type="picture-card"
                          :http-request="loadImg1"
                        >
                          <img :src="imgs.img1" class="avatar" />
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="身份证反面：" prop="name">
                    <div class="row" style>
                      <div>
                        <el-upload
                          class="avatar-uploader"
                          action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                          :show-file-list="false"
                          list-type="picture-card"
                          :http-request="loadImg2"
                        >
                          <img v-if="imgs.img2" :src="imgs.img2" class="avatar" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="手持身份证照片：" prop="name">
                    <div class="row" style>
                      <div>
                        <el-upload
                          class="avatar-uploader"
                          action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                          :show-file-list="false"
                          list-type="picture-card"
                          :http-request="loadImg3"
                        >
                          <img v-if="imgs.img3" :src="imgs.img3" class="avatar" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="营业执照照片：" prop="name">
                    <div class="row" style>
                      <div>
                        <el-upload
                          class="avatar-uploader"
                          action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                          :show-file-list="false"
                          list-type="picture-card"
                          :http-request="loadImg4"
                        >
                          <img v-if="imgs.img4" :src="imgs.img4" class="avatar" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>

                  <el-form-item label="店铺门面照片：" prop="name">
                    <div class="row" style>
                      <div>
                        <el-upload
                          class="avatar-uploader"
                          action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                          :show-file-list="false"
                          list-type="picture-card"
                          :http-request="loadImg5"
                        >
                          <img v-if="imgs.img5" :src="imgs.img5" class="avatar" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="银行卡正面图片：" prop="name">
                    <div class="row" style>
                      <div>
                        <el-upload
                          class="avatar-uploader"
                          action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                          :show-file-list="false"
                          list-type="picture-card"
                          :http-request="loadImg8"
                        >
                          <img v-if="imgs.img8" :src="imgs.img8" class="avatar" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="店铺内景照片：" prop="name">
                    <div class="row" style>
                      <div>
                        <el-upload
                          class="upload-demo"
                          action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                          :on-preview="handlePreview"
                          :on-remove="handleRemove"
                          :before-upload="beforeAvatarUpload"
                          :file-list="fileList"
                          list-type="picture"
                          :http-request="loadImg6"
                          :show-file-list="true"
                        >
                          <el-button size="small" type="primary">点击上传</el-button>
                          <div slot="tip" class="el-upload__tip">只至少上传五张，只能上传JPG/PNG，且不超过500kb</div>
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>

                  <el-form-item label="附加资料：" prop="name">
                    <div class="row" style>
                      <div>
                        <el-upload
                          class="avatar-uploader"
                          action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                          :show-file-list="false"
                          list-type="picture-card"
                          :http-request="loadImg7"
                        >
                          <img v-if="imgs.img7" :src="imgs.img7" class="avatar" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      size="small"
                      type="primary"
                      @click="nextGo"
                      :disabled="buttonDisabled"
                    >下一步</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div v-if="pages3 == 2">
              <div class="billHead2" style="height:40px;">
                <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item>
                    <a @click="pages3 = 1" href="javascript:;">店铺认证</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>填写商户信息</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="createBranch">
                <div style="width:400px;">
                  <el-form
                    :model="dynamicValidateForm2"
                    ref="dynamicValidateForm2"
                    label-width="110px"
                    class="demo-dynamic"
                    hide-required-asterisk
                    :rules="rules"
                  >
                    <el-form-item prop="type1" label="银行卡号：">
                      <el-input placeholder="请输入银行卡号" v-model.number="dynamicValidateForm2.type1"></el-input>
                    </el-form-item>
                    <el-form-item prop="type2" label="银行名称：">
                      <el-input placeholder="请输入银行名称" v-model="dynamicValidateForm2.type2"></el-input>
                    </el-form-item>
                    <el-form-item prop="type3" label="开户人名：">
                      <el-input placeholder="请输入开户人姓名" v-model="dynamicValidateForm2.type3"></el-input>
                    </el-form-item>
                    <el-form-item prop="type4" label="开户银行网点：">
                      <el-select
                        style="width:290px;"
                        v-model="dynamicValidateForm2.type4"
                        placeholder="请选择银行网点"
                      >
                        <el-option
                          v-for="item in bankList"
                          :key="item.id"
                          :label="item.bankName"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="type5" label="业务员编号：">
                      <el-input placeholder="请输入业务员编号(选填)" v-model="dynamicValidateForm2.type5"></el-input>
                    </el-form-item>
                    <el-form-item prop="type6" label="支付宝：">
                      <el-input placeholder="请输入支付宝账号" v-model="dynamicValidateForm2.type6"></el-input>
                    </el-form-item>
                    <el-form-item prop="type7" label="电子邮箱：">
                      <el-input placeholder="请输入电子邮箱" v-model="dynamicValidateForm2.type7"></el-input>
                    </el-form-item>
                    <el-form-item prop="type8" label="手机号：">
                      <el-input placeholder="请输入手机号码" v-model.number="dynamicValidateForm2.type8"></el-input>
                    </el-form-item>
                    <el-form-item prop="type9" label="商户简称：">
                      <el-input placeholder="请输入商户简称" v-model="dynamicValidateForm2.type9"></el-input>
                    </el-form-item>
                    <el-form-item prop="type10" label="银行卡户名：">
                      <el-input placeholder="请输入银行卡户名" v-model="dynamicValidateForm2.type10"></el-input>
                    </el-form-item>
                    <el-form-item prop="type11" label="支付宝户名：">
                      <el-input placeholder="请输入支付宝户名" v-model="dynamicValidateForm2.type11"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        size="small"
                        @click="paySubmitForm('dynamicValidateForm2')"
                      >完成提交审核资料</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确定删除该员工吗</span>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="delShopWorker">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="权限设置"
      :visible.sync="permissionDialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>
         <el-checkbox-group v-model="types" class="checkGroup" @change="handlePermissionChange">
          <el-checkbox  
            v-for="item in permissionList" 
            :label="item.type"   
            :key="item.type"  
            border>
            {{item.typeName}}
          </el-checkbox>
        </el-checkbox-group>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchSetGasAuth">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { uploadImg, findApplyPay, getGasAuthsList, batchSetGasAuth, findGasAuthsByUser  } from "../api";
var checkPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("手机号不能为空"));
  } else {
    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
    console.log(reg.test(value));
    if (reg.test(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的手机号"));
    }
  }
};
var checkEmail = (rule, value, callback) => {
  const mailReg = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
  if (!value) {
    return callback(new Error("邮箱不能为空"));
  } else {
    if (mailReg.test(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的邮箱格式"));
    }
  }
};
var payNUmber = (rule, value, callback) => {
  const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
  const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
  if (!value) {
    return callback(new Error("支付宝不能为空"));
  } else {
    if (mailReg.test(value) || reg.test(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的支付宝账号"));
    }
  }
};
export default {
  data() {
    return {
      status: null,
      pageNo: 1,
      workerPages: 1,
      shopDetailWorkerList: [], //门店详情员工列表
      dialogVisible: false,
      buttonDisabled: false,
      //店铺认证数组
      certificationForm: {
        shopName: ""
      },
      value: "",
      //权限
      workerType: [
        { value: 100, name: "店主" },
        { value: 101, name: "员工" }
        // { value: 103, name: "财务" }
      ], //100：店主   101:员工  102：销售员  103：财务
      // 添加员工数组
      addWords: {
        imageUrl2: require("../../assets/icon/mdzp1.png"),
        shopStoreId: "", //分店id
        phoneNum: "", //手机号
        fullName: "", //名字
        headLogo: "", //头像
        workerType: ""
      },
      //商户内景照片
      fileList: [],
      searchWorkers: "", //搜索员工
      searchShops: "", //搜索门店
      dynamicValidateForm: { name: "", location: "" }, //创建门店表单验证存储信息
      dynamicValidateForm2: {
        type1: "",
        type2: "",
        type3: "",
        type4: "",
        type5: "",
        type6: "",
        type7: "",
        type8: "",
        type9: "",
        type10: "",
        type11: ""
      }, //填写商户信息表单验证存储信息
      pages: 1, // pages == 1门店管理界面，pages == 2 创建门店界面 pages == 3 门店详情界面
      pages2: 1, // pages2 == 1员工管理界面，pages2 == 2 添加员工界面 pages2 == 3 编辑员工界面
      pages3: 1, // pages3 == 填写商户信息第一步，pages2 == 2 填写商户信息第二步
      activeName: "first", //标签栏首选
      imgs: {
        img1: require("../../assets/icon/mdzp1.png"), //门店照片上传图案
        img2: require("../../assets/icon/mdzp1.png"), //门店照片上传图案
        img3: require("../../assets/icon/mdzp1.png"), //门店照片上传图案
        img4: require("../../assets/icon/mdzp1.png"), //门店照片上传图案
        img5: require("../../assets/icon/mdzp1.png"), //门店照片上传图案
        img7: require("../../assets/icon/mdzp1.png"), //门店照片上传图案
        img8: require("../../assets/icon/mdzp1.png") //门店照片上传图案
      },
      img1: require("../../assets/icon/mdzp1.png"),
      //表单规则
      rules: {
        type1: [
          { required: true, message: "请输入银行卡号", trigger: "blur" },
          { type: "number", message: "请输入数字", trigger: "blur" }
        ],
        type2: [{ required: true, message: "请输入银行名称", trigger: "blur" }],
        type3: [
          { required: true, message: "请输入开户人姓名", trigger: "blur" }
        ],
        type4: [
          { required: true, message: "请选择开户银行网点", trigger: "blur" }
        ],
        type5: [{ required: false, trigger: "blur" }],
        type6: [
          { required: true, message: "请输入支付宝账号", trigger: "blur" },
          { validator: payNUmber, trigger: "blur" }
        ],
        type7: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" }
        ],
        type8: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        type9: [{ required: true, message: "请输入商户简称", trigger: "blur" }],
        type10: [
          { required: true, message: "请输入银行卡户名", trigger: "blur" }
        ],
        type11: [
          { required: true, message: "请输入支付宝户名", trigger: "blur" }
        ]
      },
      workersList: [], //员工列表
      shopList: [], //门店列表
      shopList2: [], //门店列表
      shopList3: [],
      shopDetailList: [], // 门店详情
      userList: "", //用户信息
      shopInformation: "", //店铺信息
      totalMoney: "", //总计收款
      imgUploadForm: {
        file: null,
        isCompre: 1, //1压缩(默认的) 2不压缩
        isCutImage: 1, //1.需要切(默认的) 2.不需切的图片(小部分)
        fileContentType: "", //image/png //image/jpeg
        fileFileName: ""
      },
      createShopFrom: { shopName: "", shopAddress: "" }, //创建分店from
      editShopFrom: { shopName: "", shopAddress: "" }, //修改分店from
      editWorkerFrom: {
        fullName: "",
        headLogo: "",
        phoneNum: "",
        storeName: "",
        roleId: "",
        img: require("../../assets/icon/mdzp1.png"),
        roleName: ""
      }, //修改分店from
      editShop: "", //所编辑的门店信息
      editWorkerId: "",
      workerId: "", //删除员工所需id
      detailShopStoreId: "", //详情页id
      roleList: [
        { roleId: '101', name: '收银员' },
        { roleId: '102', name: '销售员' },
        { roleId: '103', name: '财务' }
      ],
      permissionDialogVisible: false,
      permissionList: [],
      types: [],
      shopWorkerUserId: ""
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    if (this.$route.query.docId) {
      this.activeName = this.$route.query.docId;
    }
    //银行开户网点
    this.request
      .post("qrcapi/Shop_getOpenAccountLocation", {
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      })
      .then(res => {
        if (res.code == 1) {
          // this.$message({
          //   message: res.msg,
          //   type: "success"
          // });
          this.bankList = res.data;
          console.log(res, "银行开户网点");
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    // var arr = this.dynamicValidateForm2;
    //         bankAccountNo: arr.type1, //卡号
    //         bankName: arr.type2, //银行名称
    //         linkName: arr.type3, //联系人姓名
    //         bankLocation: arr.type4, //开户行网点
    //         promoterInfo: arr.type5, //业务员编号
    //         alipayAccount: arr.type6, //支付宝账号
    //         contactEmail: arr.type7, //联系人邮箱
    //         linkTel: arr.type8, //联系人手机号码
    //         shopName: arr.type9, //商户简称
    //         bankAccountName: arr.type10, //银行卡户名
    //         alipayPersonName: arr.type11 //支付宝户名
    //店铺认证回显
    findApplyPay({
      sessionId: this.userList.sessionId,
      userId: this.userList.id
    }).then(res => {
      console.log(res, "res");
      var infromationList = this.dynamicValidateForm2;
      if (res.code == 1) {
        var imgList = res.data.shopImages.split(",");
        var arr = [];
        for (let i in imgList) {
          var index = imgList[i].lastIndexOf("/");
          var str = imgList[i].substring(index + 1, imgList[i].length);
          arr.push({ name: str, url: imgList[i] });
        }
        infromationList.type1 = Number(res.data.bankAccountNo);
        infromationList.type2 = res.data.bankName;
        infromationList.type3 = res.data.linkName;
        infromationList.type4 = res.data.bankLocation;
        infromationList.type5 = res.data.promoterInfo;
        infromationList.type6 = res.data.alipayAccount;
        infromationList.type7 = res.data.contactEmail;
        infromationList.type8 = res.data.linkTel;
        infromationList.type9 = res.data.shopName;
        infromationList.type10 = res.data.bankAccountName;
        infromationList.type11 = res.data.alipayPersonName;
        this.imgs.img1 = res.data.idFrontImage;
        this.imgs.img2 = res.data.idBackImage;
        this.imgs.img3 = res.data.idPersonalImage;
        this.imgs.img4 = res.data.businessLicenceImage;
        this.imgs.img5 = res.data.shopFaceImage;
        this.fileList = arr;
        this.imgs.img7 = res.data.attachImages;
        this.imgs.img8 = res.data.bankFrontImage;
      }
    });
    //门店列表
    this.Shop_shopStores(1, "", 10);
    // this.Shop_shopStores("", "", 99999);
    //员工列表
    this.Shop_shopWorkers();
  },
  mounted() {
    this.Shop_findShopStores()
  },
  destroyed() {
    localStorage.removeItem("searchShops")
  },
  methods: {
    handleClose() {
      this.permissionDialogVisible = false
    },
    handlePermissionChange(val) {
      console.log(val)
    },
    getGasAuthsList() {
      getGasAuthsList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
      })
      .then(res => {
        if (res.code == 1) {
          this.permissionList = res.data
        }
      })
    },
    set_permission(row) {
      this.shopWorkerUserId = row.shopWorkerUserId
      this.permissionDialogVisible = true
      this.getGasAuthsList()
      this.findGasAuthsByUser()
    },
    findGasAuthsByUser() {
      findGasAuthsByUser({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        workUserId: this.shopWorkerUserId
      })
      .then(res => {
        if (res.code == 1) {
          res.data.forEach(val => {
            this.types.push(val.edcAuthType);
          });
        } else if (res.code == -1) {
          this.types = []
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    batchSetGasAuth() {
      console.log(this.types)
      let authsParams = []
      this.permissionList.forEach(val => {
        if (~this.types.indexOf(val.type)) {
          authsParams.push({
            edcAuthType: val.type,
            isEnable: 1
          });
        } else {
          authsParams.push({
            edcAuthType: val.type,
            isEnable: 0
          });
        }
      });
      batchSetGasAuth({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        edcAuthJson: JSON.stringify(authsParams),
        workUserId: this.shopWorkerUserId
      })
      .then(res => {
        this.permissionDialogVisible = false
        if (res.code == 1) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 分店下拉框列表
    Shop_findShopStores() {
      this.request
        .post("qrcapi/Shop_findShopStores", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          pageNo: 1,
          row: 999
        })
        .then(res=> {
          console.log(res.data, "分店下拉框列表")
          var shopList2 = JSON.parse(JSON.stringify(res.data))
          var shopList3 = JSON.parse(JSON.stringify(res.data))
          this.shopList2 = shopList2
          this.shopList3 = shopList3
          this.shopList3.unshift({shopStoreId: "", storeName: "全部分店"})
        })
    },
    toManage() {
      this.pages2 = 1
      this.Shop_shopWorkers(1)
      this.$forceUpdate()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 < 500;

      if (!isJPG) {
        this.$message.error("上传内景图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传内景图片大小不能超过 500kb!");
      }
      return isJPG && isLt2M;
    },
    nextGo() {
      // this.pages3 = 2;
      this.buttonDisabled = true;
      setTimeout(() => {
        this.buttonDisabled = false;
      }, 5000);
      let outNumber = 0;
      for (let i in this.imgs) {
        if (this.imgs[i] == this.img1) {
          outNumber += 1;
        }
      }
      if (outNumber !== 0) {
        this.$message({
          type: "error",
          message: "您有" + outNumber + "张图片未传"
        });
      } else if (this.fileList.length < 5) {
        this.$message({
          type: "error",
          message: "店铺内景照片至少上传五张"
        });
      } else {
        this.pages3 = 2;
      }
    },
    //支付认证
    Shop_submitApplyPay() {
      var arr = this.dynamicValidateForm2;
      var imgs = this.imgs;
      var fileList = this.fileList;
      var imglist = fileList[0].url;
      for (let i in fileList) {
        if (i != 0) {
          imglist = imglist + "," + fileList[i].url;
        }
      }
      console.log(imglist, fileList, "333");
      this.request
        .post("qrcapi/Shop_submitApplyPay", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          idFrontImage: imgs.img1, //身份证正面照片
          idBackImage: imgs.img2, //身份证背面照片
          idPersonalImage: imgs.img3, //手持身份证照片
          businessLicenceImage: imgs.img4, //营业执照照片
          shopFaceImage: imgs.img5, //店铺门头照片
          shopImages: imglist, //店铺内景照片
          attachImages: imgs.img7, // 附加资源图片 【可空】 【50张图片为上限】
          bankFrontImage: imgs.img8, //银行卡正面图片
          bankAccountNo: arr.type1, //卡号
          bankName: arr.type2, //银行名称
          linkName: arr.type3, //联系人姓名
          bankLocation: arr.type4, //开户行网点
          promoterInfo: arr.type5, //业务员编号
          alipayAccount: arr.type6, //支付宝账号
          contactEmail: arr.type7, //联系人邮箱
          linkTel: arr.type8, //联系人手机号码
          shopName: arr.type9, //商户简称
          bankAccountName: arr.type10, //银行卡户名
          alipayPersonName: arr.type11 //支付宝户名
        })
        .then(res => {
          console.log(res, "支付认证");
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success"
            });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    shopChange() {
      console.log(this.value, "change");
      this.Shop_shopWorkers();
    },
    addWorkers() {
      console.log(123)
      this.Shop_shopStores(1, "", 999, 999);
      this.pages2 = 2
    },
    //编辑店员
    redactWorks(item) {
      console.log(item, "item")
      if (item.workerType == 103) {
        this.editWorkerFrom.roleName = "财务"
      } else if (item.workerType == 101) {
        this.editWorkerFrom.roleName = "收银员"
      } else if (item.workerType == 102) {
        this.editWorkerFrom.roleName = "销售员"
      } else if (item.workerType == 100) {
        this.editWorkerFrom.roleName = "店长"
      }
      this.pages2 = 3;
      this.activeName = "second";
      this.editWorkerId = item;
      this.editWorkerFrom.fullName = item.fullName;
      this.editWorkerFrom.storeName = item.storeName;
      this.editWorkerFrom.headLogo = item.headLogo;
      this.editWorkerFrom.phoneNum = item.phoneNum;
      this.editWorkerFrom.img = item.headLogo;
      this.editWorkerFrom.roleId = item.roleId
    },
    workerToHome() {
      this.pages2 = 1;
      this.Shop_shopWorkers(1);
    },
    //删除员工
    delShopWorker(e) {
      console.log(this.workerPages, "this.workerPages");
      this.dialogVisible = false;
      this.request
        .post("qrcapi/Shop_delShopWorker", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopWorkerUserId: this.workerId
        })
        .then(res => {
          if (res.code == 1) {
            this.pages = 1;
            this.Shop_shopStores();
            this.Shop_shopStores("", "", 99999);
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.Shop_shopWorkers(this.workerPages);
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //搜索
    searchRequest(e) {
      console.log(e)
      this.status = 1
      localStorage.setItem("searchShops", this.searchShops)
      if (e == "workers") {
        console.log(this.searchWorkers);
        this.Shop_shopWorkers(1, this.searchWorkers);
      } else if (e == "shops") {
        this.Shop_shopStores(1, this.searchShops);
        this.pageNo = 1
      }
    },
    searchContentBlur(e) {
      if (e.target.value.length == 0) {
        localStorage.removeItem("searchShops")
      }
    },
    //员工列表
    Shop_shopWorkers(pageNumber, fullName) {
      this.request
        .post("qrcapi/Shop_shopWorkers", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          pageNumber: pageNumber, // 当前页码
          pageSize: 20, // 每页记录数
          shopStoreId: this.value, //分店Id
          phoneNum: fullName //员工姓名
        })
        .then(res => {
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            console.log(res, "员工列表");
            this.workersList = res.data;
            this.workerPages = res.data.requestVo.pageNumber
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //门店列表
    Shop_shopStores(pageNo, shopStoreName, pageSize, row) {
      if (!pageSize) {
        pageSize = 10;
      }
      this.request
        .post("qrcapi/Shop_shopStores", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          pageNo: pageNo,
          storeName: shopStoreName, //门店名称
          pageSize: pageSize,
          row: row
        })
        .then(res => {
          if (res.code == 1) {
            this.request
              .post("qrcapi/Shop_shopStoresTotalNum", {
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                storeName: shopStoreName //门店名称
              })
              .then(e => {
                console.log(e, "门店记录数");
                var totalMoney = 0;
                for (let i in res.data.list) {
                  totalMoney += Number(res.data.list[i].gainMoney);
                }
                // if (pageSize != 10) {
                //   this.shopList2 = res.data;
                // } else {
                //   this.shopList2 = res.data;
                //   this.shopList = res.data;
                //   this.shopList.totalCount = e.data.totalNum;
                //   console.log(this.shopList, "素有门店2");
                // }
                  // this.shopList2 = res.data;
                  this.shopList = res.data;
                  this.shopList.totalCount = e.data.totalNum;
                  console.log(this.shopList, "素有门店2");
                this.totalMoney = totalMoney;
              });
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            console.log(res, "素有门店");
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    edit(e) {
      console.log(e);
      this.pages = 4;
      this.editShop = e;
      this.editShopFrom.shopName = e.storeName;
      this.editShopFrom.shopAddress = e.storeAddress;
    },
    Shop_shopWorkers_two(pageNumber) {
      this.request
        .post("qrcapi/Shop_shopWorkers", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopStoreId: this.detailShopStoreId,
          pageNumber: pageNumber,
          pageSize: 5
        })
        .then(res => {
          console.log(res, "门店详情员工列表");
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            var arr = res.data.pager;

            this.shopDetailWorkerList = res.data.pager;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    workDetail(e) {
      this.pages = 3;
      this.shopDetailList = "";
      this.detailShopStoreId = e.shopStoreId;
      this.Shop_shopWorkers_two(1);
      //门店详情
      this.request
        .post("qrcapi/Shop_shopStoreDeatil", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopStoreId: e.shopStoreId
        })
        .then(res => {
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            this.shopDetailList = res.data;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
      console.log(this.shopDetailList);
    },
    //商户内景照片

    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    //创建分店
    Shop_createShopStore(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.request
            .post("qrcapi/Shop_createShopStore", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              storeName: this.createShopFrom.shopName,
              storeAddress: this.createShopFrom.shopAddress
            })
            .then(res => {
              if (res.code == 1) {
                this.$message({
                  message: res.msg,
                  type: "success"
                });
                this.createShopFrom = { shopName: "", shopAddress: "" };
                this.Shop_shopStores(); //门店列表
                this.pages = 1;
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改分店
    Shop_updateShopStore(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.request
            .post("qrcapi/Shop_updateShopStore", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              storeName: this.editShopFrom.shopName,
              storeAddress: this.editShopFrom.shopAddress,
              shopStoreId: this.editShop.shopStoreId
            })
            .then(res => {
              if (res.code == 1) {
                this.$message({
                  message: res.msg,
                  type: "success"
                });
                this.Shop_shopStores(); //门店列表
                this.pages = 1;
                this.pageNo = 1
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    shopToHome() {
      this.pages = 1;
      this.Shop_shopStores(1);
      this.createShopFrom = { shopName: "", shopAddress: "" };
    },

    paySubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.Shop_submitApplyPay(); //提交
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 添加员工
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var addWords = this.addWords;
          var id = addWords.shopStoreId.split(",");
          var shopStoreId = Number(id[0]);
          var shoperUserId = Number(id[1]);
          this.request
            .post("qrcapi/Shop_createShopWorker", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              shopStoreId: shopStoreId,
              shoperUserId: shoperUserId,
              fullName: addWords.fullName,
              headLogo: addWords.headLogo,
              workerType: addWords.roleId,
              phoneNum: addWords.phoneNum
            })
            .then(res => {
              console.log(res, "添加员工111");
              this.Shop_shopStores();
              this.Shop_shopStores("", "", 99999);
              if (res.code == 1) {
                this.$message({
                  message: res.msg,
                  type: "success"
                });
                this.Shop_shopWorkers(); //员工列表
                // this.shopDetailList = res.data;
                this.pages2 = 1;
                this.addWords = {
                  imageUrl2: require("../../assets/icon/mdzp1.png"),
                  shopStoreId: "", //分店id
                  phoneNum: "", //手机号
                  fullName: "", //名字
                  headLogo: "", //头像
                  workerType: ""
                };
                this.$forceUpdate()
                this.request
                  .post("qrcapi/Shop_registCaptcha", {
                    sessionId: this.userList.sessionId,
                    userId: this.userList.id,
                    shopWorkerUserId: res.data.shopWorkerUserId
                  })
                  .then(e => {
                    console.log(e, "发送手机号");
                  });
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else if (res.code == 0) {
                this.$message.error("该手机号已注册其他类型账号，不可操作");
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑员工提交
    Shop_updateShopWorker(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var editWorkerFrom = this.editWorkerFrom;
          var editWorkerId = this.editWorkerId;
          // console.log(editWorkerFrom.phoneNum)
          this.request
            .post("qrcapi/Shop_updateShopWorker", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              shopWorkerUserId: editWorkerId.shopWorkerUserId,
              shopStoreId: editWorkerId.shopStoreId,
              fullName: editWorkerFrom.fullName,
              headLogo: editWorkerFrom.headLogo,
              workerType: editWorkerFrom.roleId,
              phoneNum: editWorkerFrom.phoneNum
            })
            .then(res => {
              console.log(res, "编辑员工");
              if (res.code == 1) {
                this.$message({
                  message: res.msg,
                  type: "success"
                });
                this.Shop_shopWorkers(); //员工列表
                this.shopDetailList = res.data;
                this.pages2 = 1;
                this.editWorkerFrom = {
                  fullName: "",
                  headLogo: "",
                  phoneNum: "",
                  img: require("../../assets/icon/mdzp1.png")
                };
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 控制门店照片上传
    handleAvatarSuccess1(res, file) {
      //上传成功时
      this.imageUrl1 = URL.createObjectURL(file.raw);
      console.log(res, file);
    },

    //图片上传失败
    error() {
      console.log("error");
    },
    loadImg1(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.imgs.img1 = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    loadImg2(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.imgs.img2 = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    loadImg3(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.imgs.img3 = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    loadImg4(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.imgs.img4 = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    loadImg5(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.imgs.img5 = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    loadImg6(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            var index = res.data.data.url.lastIndexOf("/");
            var str = res.data.data.url.substring(index + 1, res.data.data.url.length);
            this.fileList.push({name:str, url:res.data.data.url});
            console.log(this.fileList, "fileList");
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    loadImg7(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.imgs.img7 = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    loadImg8(res) {
      console.log(123);
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.imgs.img8 = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    editHandleAvatarSuccess2(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      console.log(imgUploadForm, "1");
      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.editWorkerFrom.img = res.data.data.url;
            this.editWorkerFrom.headLogo = res.data.data.url;
            this.imgs.img1 = res.data.data.url;
            console.log(res, "uploadImg");
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    handleAvatarSuccess2(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      console.log(imgUploadForm, "1");
      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.addWords.imageUrl2 = res.data.data.url;
            this.addWords.headLogo = res.data.data.url;
            console.log(res, "uploadImg");
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },

    myUpload(content) {
      console.log(content);
      let formData = new FormData();
      formData.append("logo", content.file); // 'file[]' 代表数组 其中`file`是可变的
      console.log(formData);
      this.request
        .post("https://api.yichengshi.cn/ImageServer/YmUpload_image", {
          File: formData.file,
          imageCaptchaToken: this.imageCaptchaToken,
          imageCaptchaCode: this.imgToken
        })
        .then(response => {
          this.reqImg();
          console.log(response);
          if (response.code == 1) {
            this.$message({
              type: "success",
              message: response.msg
            });
          } else {
            this.$message.error(response.msg);
          }
          console.log(response);
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
      // this.request.post(content.action,formData).then(rs=>{
      //   this.$store.dispatch('GetInfo')
      // }).catch(err=>{
      //   this.$store.dispatch('LogMessage', "用户头像上传失败!")
      //   console.log(err)
      // })
    },

    // 管理门店分页
    shopSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    shopPageChange(val) {
      this.pageNo = val
      console.log(this.status, 'status')
      var searchShops = ""
      searchShops = localStorage.getItem("searchShops")
      if (this.status == 1) {
        this.Shop_shopStores(val, searchShops)
      } else {
        this.Shop_shopStores(val)
      }
    },
    //分页选择每页多少条
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    // 员工列表分页
    workersChange(val) {
      this.workerPages = val;
      this.Shop_shopWorkers(val);
      console.log(`当前页: ${val}`);
    },
    //分页当前页
    handleCurrentChange(val) {
      this.Shop_shopWorkers_two(val);
    }
  }
};
</script>

<style scoped>
.billHead2 {
  box-sizing: border-box;
  width: 100%;
  background: #f8f8f8;
  padding: 13px 0 0 30px;
  position: fixed;
  top: 39px;
  z-index: 100;
}
.contentTabs {
  padding: 10px 0 0 0px;
}
.middlePart {
  background: #f8f8f8;
  padding: 20px 30px;
  position: fixed;
  width: calc(100vw - 200px);
  box-sizing: border-box;
  top: 39px;
}
.content {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px;
  margin-top: 70px;
  color: #606266;
  font-size: 14px;
}
.input1 {
  width: 200px;
  margin-left: 20px;
  height: 30px;
}
.table {
  width: 100%;
  font-size: 12px;
}
.th {
  background: #f8f8f8;
  padding: 15px;
  height: 40px;
  font-size: 14px;
  color: #909399;
  font-weight: 600;
}
.th2 {
  background: #fffae4;
  padding: 15px;
  height: 40px;
  font-size: 14px;
  color: #909399;
  font-weight: 600;
}
.th2 td {
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
}
.th2 td:first-child {
  text-align: left;
  padding-left: 17px;
}
.th td {
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  text-align: center;
}
.th td:first-child {
  text-align: left;
  padding-left: 17px;
}
.th td:last-child {
  text-align: right;
  padding-right: 28px;
}
td {
  font-size: 14px;
  padding: 0;
  margin: 0;
  /* width: 25%; */
}
table {
  border: 0;
  border-collapse: 0;
  border-spacing: 0;
  font-size: 14px;
}
.td td {
  height: 55px;
  border-bottom: 1px solid #ebeef5;
  text-align: center;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
}

.td td:first-child {
  text-align: left;
  padding-left: 17px;
}
.td td:last-child {
  padding-right: 17px;
  text-align: right;
}
.button1 {
  width: 45px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
}
.button3 {
  height: 30px;
  width: 70px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
}
.button2 {
  height: 30px;
  width: 70px;
  padding: 0;
}
.createBranch {
  padding: 40px 30px;
  margin-top: 40px;
}
.text1 {
  font-size: 14px;
  color: #606266;
  height: 62px;
  line-height: 62px;
  margin-left: -10px;
  margin-right: 10px;
}
.text2 {
  font-size: 12px;
  color: #bbb;
  margin-top: 10px;
}
.padding30 {
  padding: 30px;
}
.head {
  background: #f8f8f8;
  padding: 30px 40px;
  position: relative;
}
.text3 {
  font-size: 13px;
}
.text4 {
  font-size: 24px;
  margin-top: 10px;
}
.shop {
  background: #fff;
  padding: 16px 18px;
  position: absolute;
  right: 20px;
  top: 25px;
  font-size: 12px;
  height: calc(100% - 80px);
  width: 510px;
}
.text5 {
  /* color: #bbb; */
  margin-top: 10px;
  width: 510px;
  overflow:hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
table img {
  height: 30px;
  width: 30px;
}
.text6 {
  margin-left: 20px;
}
.BusinessInformation {
  padding: 30px 50px;
  font-size: 14px;
  margin-top: 40px;
}
.loadImg {
  margin-left: 45px;
}
.item {
  margin-top: 30px;
}
.loadItem {
  margin-left: 20px;
}
.searchButton {
  width: 50px;
  height: 30px;
  padding: 0;
  margin-left: 10px;
}
.permission-btn {
  width: 80px!important;
  height: 30px!important;
  padding: 0!important;
  color: #409eff!important;
  border: 1px solid #409eff!important;
}
</style>


// WEBPACK FOOTER //
// src/components/page/set.vue